import React from "react";
import { numberFormatters } from "common";
import "./moneyCellRenderer.scss";
import { NumberFormatKind } from "common/types";
import { useWidgetCurrentDataScale } from "components/widgets/hooks/use-current-widget";
export const MoneyCellRenderer = (params) => {
    const currentDataScale = useWidgetCurrentDataScale(params.sectionId, params.widgetId);
    if (!params.value && params.value !== 0) {
        return React.createElement("span", null);
    }
    const { currency } = params.value;
    const value = params.value.value === undefined ? params.value.amount : params.value.value;
    if ((value || value === 0) && !isNaN(value) && currency) {
        return React.createElement("span", { className: "moneyCellRenderer" },
            numberFormatters(value, NumberFormatKind.compact, { maximumFractionDigits: 2, minimumFractionDigits: 2 }, currentDataScale),
            " ",
            React.createElement("span", { className: "currency" }, currency));
    }
    return React.createElement("span", null);
};
export const formatMoneyCellValue = (value, dataScale) => {
    if (!value && value !== 0) {
        return "";
    }
    const { currency } = value;
    const val = value.value === undefined ? value.amount : value.value;
    if ((val || val === 0) && !isNaN(val) && currency) {
        return `${numberFormatters(val, NumberFormatKind.compact, { maximumFractionDigits: 2, minimumFractionDigits: 2 }, dataScale)} ${currency}`;
    }
    return "";
};
